import { render } from "./Paginator.vue?vue&type=template&id=17b1056a&scoped=true&ts=true"
import script from "./Paginator.vue?vue&type=script&lang=ts"
export * from "./Paginator.vue?vue&type=script&lang=ts"

import "./Paginator.vue?vue&type=style&index=0&id=17b1056a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b1056a"]])

export default __exports__